import { Role } from "../../types/role";

const TSve: Role = {
  primary: [
    "Deckung",
    "Tackling",
    "Antizipation",
    "Einsatzfreude",
    "Konzentration",
    "Stellungsspiel",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Kopfball",
    "Passen",
    "Aggressivitaet",
    "Entscheidungen",
    "Mut",
    "Nervenstaerke",
    "Kraft",
    "Sprunghoehe",
  ],
  physis: "mittelfeld",
};

export const TS = {
  TSve,
};
